import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { getProductKeyFromCTType } from '@grandvisionhq/utils';
import { ProductBlock } from '../../ProductBlock/components/ProductBlock.js';
import { getZeroDiscount } from '../utils/get-zero-discount.js';
import { convertProductRecommendationInfo } from '../utils/mappers.js';

var ProductRecommendation = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { recommendation  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "recommendation"
    ]);
    const productLink = useLink({
        route: 'products.detail',
        params: {
            slug: recommendation.slug,
            sku: recommendation.sku,
            key: getProductKeyFromCTType(recommendation.productType)
        }
    });
    const info = convertProductRecommendationInfo(recommendation, productLink ? productLink.href : '#');
    if (!info) return null;
    const { sku , tags  } = info, recommendationRest = swcHelpers.objectWithoutProperties(info, [
        "sku",
        "tags"
    ]);
    const productTag = (tags === null || tags === void 0 ? void 0 : tags[0]) || getZeroDiscount(recommendation);
    return /*#__PURE__*/ React.createElement(ProductBlock, swcHelpers.extends({
        ref: ref,
        activeSku: sku
    }, recommendationRest, {
        /* We have to pass onVariantChange given it is not optional, even though
         * we know we will never have variants on recommendations.
         */ /* eslint-disable-next-line @typescript-eslint/no-empty-function */ onVariantChange: ()=>{},
        /**
         * Some other props that are required but we don't need (yet).
         */ variants: [],
        isInsuranceReimbursable: false,
        /* Take the first tag as the product tag.
         * We currently don't have the percent based discount information in graphql to perform the proper fallback logic.
         */ tag: productTag
    }, rest));
});

export { ProductRecommendation };
//# sourceMappingURL=ProductRecommendation.js.map
